<div class="container row">
    <div *ngIf="false" class="col-12 d-flex flex-row justify-content-between align-items-center">
        <div class="apartado-item-head-opt">
            <span class="gl-text-primary">Subir Logo</span>
            <p class="gl-text-secondary">
                Sube tu logo arrastrándolo aquí o seleccionándolo desde tu dispositivo.
            </p>
        </div>
        <div>
            <input class="form-control" type="file" id="formFile">
        </div>
    </div>


    <app-config-line
        [title]="'CONFIGURATION.SECTIONS.PREFERENCES.THEME_CUSTOM.LABEL' | translate"
        [description]="'CONFIGURATION.SECTIONS.PREFERENCES.THEME_CUSTOM.DESCRIPTION' | translate "
        [withHr]="false"
        [filterBy]="filterOptionsBy"
    >
        <p-dropdown [(ngModel)]="themeSelected" (onChange)="selectTheme()" [options]="themeOptions"
        optionLabel="name" optionValue="value"></p-dropdown>
    </app-config-line>


    <app-config-line
        [title]="'Personalizar Color Principal'"
        [description]="'Personaliza los colores de tu tema eligiendo las opciones que más te gusten.'"
        [render]="themeSelected == themeNames.Custom"
        [filterBy]="filterOptionsBy"
    >
        <input type="color" [(ngModel)]="primaryColor" (change)="changePrimaryColor()" class="color-picker" />
    </app-config-line>

    <div *ngIf="false">
        <div class="col-12 d-flex flex-row justify-content-between align-items-center">
            <div class="apartado-item-head-opt">
                <span class="gl-text-primary">Personalizar Colores del Tema</span>
                <p class="gl-text-secondary">
                    Personaliza los colores de tu tema eligiendo las opciones que más te gusten.
                </p>
            </div>

            <div>
                <button class="btn gl-button-primary">Colores</button>
            </div>
        </div>
    </div>
</div>